import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { FacturaService } from 'src/app/services/factura.service';
import { Factura } from 'src/app/models/factura.interface';

@Component({
  selector: 'app-producto-form',
  templateUrl: './producto-form.component.html',
  styleUrls: ['./producto-form.component.scss']
})
export class ProductoFormComponent {
  productoForm!: FormGroup;
  submitted = false;
  public facturas: Factura[] = [];

  constructor(private fb: FormBuilder, private facturaService: FacturaService, private auth: AuthService) { }

  ngOnInit(): void {
    this.productoForm = this.createFormulario();
    this.cargarCatalogos();
  }

  getControl(name: string): AbstractControl {
    return this.productoForm.get(name)!;
  }
  cargarCatalogos(): void {
    let id = this.auth.Session?.id;
  }
  onSubmit(): void {
    //console.log('Submit:')
    this.submitted = true;
    if (this.productoForm.invalid) {
      this.productoForm.markAllAsTouched();
      //  console.log('Formulario invalido')
      return;
    }
    // aquí iría la llamada a tu servicio para guardar...
    console.log('Payload:', this.productoForm.getRawValue());
  }

  createFormulario(): FormGroup {
    return this.fb.group({
      id_producto: [{ value: null, disabled: true }],
      nom_producto: ['', [Validators.required, Validators.maxLength(100)]],
      presentacion: ['', [Validators.required, Validators.maxLength(150)]],
      nombre_hospital: ['', [Validators.required, Validators.maxLength(255)]],
      nombre_medico: ['', [Validators.required, Validators.maxLength(150)]],
      fecha_caducidad: ['', Validators.required],
      fk_factura: ['', [Validators.required]],
    });

  }

}
